import {
    useState,
    useEffect,
    useRef,
    memo
} from 'react'
import { useRestFetch } from '@shared/hooks/rest/fetch'
import { useDashboard } from '@app/layouts/dashboard/Provider'
import { useUser } from '@shared/hooks/user'

import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ListSubheader from '@mui/material/ListSubheader'
import List from '@mui/material/List'
import Divider from '@mui/material/Divider'
import LinearProgress from '@mui/material/LinearProgress'
import RefreshButton from './Refresh'
import EstimationsList from '@shared/components/estimations/List'
import Welcoming from './Welcoming'
import AskLocation from './AskLocation'
import { AnimatePresence } from 'framer-motion'
import ConsultantItem from '@shared/components/ConsultantItem'
import axios from '@shared/utils/axios'

export default memo(function QuickLook() {
    const [welcomingOpen, setWelcomingOpen] = useState(false)
    const [askLocationOpen, setAskLocationOpen] = useState(false)
    const allowedLocation = useRef(false)
    const { setTitle } = useDashboard()
    const user = useUser()

    const handleWelcomingClose = async () => {
        setWelcomingOpen(false)

        if (allowedLocation.current == false) { setAskLocationOpen(true) }

        try { await axios.post('settings/users/welcome/') }
        catch (e) { console.log(e) }
    }

    const handleLocationClose = () => {
        localStorage.setItem('allowedLocation', true)
        setAskLocationOpen(false)
    }

    // data
    const query = useRestFetch({
        key: ['quick-look'],
        endpoint: 'estimations/quick-look/'
    })

    useEffect(() => {
        setTitle('نظرة سريعة')
        if (localStorage.getItem('allowedLocation')) { allowedLocation.current=true }
        if (user.is_welcomed) { if (allowedLocation.current == false) setAskLocationOpen(true) }
        else { setWelcomingOpen(true) }
    }, [])

    return (
        <Stack sx={{
            height: '100%',
            overflow: 'hidden'
        }}>
            <RefreshButton />
            {query.isFetching
                ? <LinearProgress />
                :
                    <>
                        <AnimatePresence>
                            {welcomingOpen &&
                                <Welcoming
                                    user={user}
                                    onClose={handleWelcomingClose}
                                />
                            }
                            {askLocationOpen &&
                                <AskLocation
                                    user={user}
                                    onClose={handleLocationClose}
                                />
                            }
                        </AnimatePresence>
                        <List sx={{
                            height: '100%',
                            overflow: 'auto'
                        }}>
                            {query.data?.today_estimations?.length > 0 &&
                                <>
                                    <ListSubheader sx={{top: -10}}>مقايسات اليوم</ListSubheader>
                                    <EstimationsList
                                        estimations={query.data?.today_estimations || []}
                                        itemsOnly={true}
                                    />
                                    <Divider />
                                </>
                            }
                            {query.data.active_users.length > 0 &&
                                <ListSubheader sx={{top: -10}}>المهندسين النشطين</ListSubheader>
                            }
                            {query.data.active_users.map(user =>
                                <ConsultantItem
                                    key={user.id}
                                    id={user.id}
                                    name={user.name}
                                    lastActivity={user.last_activity}
                                />
                            )}
                        </List>
                        <br/>
                        <br/>
                        <Box sx={{
                            position: 'fixed',
                            bottom: 0,
                            borderTopWidth: '1px',
                            borderTopColor: 'divider',
                            borderTopStyle: 'solid',
                            width: '100%',
                            display: 'flex',
                            flexDirection: 'row',
                            p: 1,
                            bgcolor: 'background.default',
                            gap: 2
                        }}>
                            <Typography variant='body2'>الإجمالي: {query.data.estimations_count}</Typography>
                        </Box>
                    </>
            }
        </Stack>
    )
})